export default __webpack_public_path__ + "static/media/nounDog1614015Blue.2e9ffc7f.svg";